import { AppUpdate } from '@capawesome/capacitor-app-update';
import { Button } from '@mui/material';
import { SnackbarKey, closeSnackbar, enqueueSnackbar } from 'notistack';
import { useEffect, useRef } from 'react';
import { useTranslation } from 'react-i18next';
import {
  setMessageShownAt,
  shouldShowUpgradeMessage,
} from './useAppUpgradeNotification.utils';
import { APPLE_APP_STORE_ID } from '../../constants';

export const useAppUpgradeNotification = (): void => {
  const { t } = useTranslation();
  const snackbarRef = useRef<SnackbarKey>();

  const handleClickUpgrade = async (): Promise<void> => {
    await AppUpdate.openAppStore({ appId: APPLE_APP_STORE_ID }); // appId is ignored by Android play store

    if (snackbarRef.current) {
      closeSnackbar(snackbarRef.current);
      snackbarRef.current = undefined;
    }
  };

  useEffect(() => {
    shouldShowUpgradeMessage(t).then((result) => {
      if (!result.shouldShow) {
        return;
      }

      snackbarRef.current = enqueueSnackbar(result.message, {
        variant: 'warning',
        persist: true,
        action: () => (
          <Button
            size="small"
            variant="watchduty-text-uppercase"
            onClick={handleClickUpgrade}
          >
            {t('home.upgrade.cta')}
          </Button>
        ),
      });

      setMessageShownAt(new Date());
    });

    return () => {
      if (snackbarRef.current) {
        closeSnackbar(snackbarRef.current);
        snackbarRef.current = undefined;
      }
    };
  }, [t]);
};
